export default __webpack_public_path__ + "static/media/plain-sticker-q.23add274.png";